<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="scroll-box">
                <v-container class="modal-container">
                    <h1>Códigos de recuperação</h1>
                    <v-row>
                        <v-col>
                            <em>Coloque esses códigos em um lugar seguro</em>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            Se você perder seu telefone ou app e não possuir um código
                            de recuperação seu acesso ao sistema será impossível.
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="codes-col">
                            <v-row v-for="(code, index) in columnA" :key="index">
                                <v-col>{{              code }}</v-col>
                                <v-col>{{ getColumnB(index) }}</v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </div>

        <v-btn icon
            class="close-btn"
            :disabled="loading"
            @click="$emit('close')">
            <img src="@/assets/icons/close.svg"
                alt="dashboard"
                class="icon" />
        </v-btn>
    </div>
</template>

<style lang="css">
</style>

<style lang="css" scoped>
.close-btn {
  position: fixed;
  top: 6%;
  right: 6%;
}
.modal-mask {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0px auto;
  padding: 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.modal-wrapper > .scroll-box {
  max-width: 90% !important;
  width: 90% !important;
  max-height: 90% !important;
  height: 90% !important;
  margin: auto;
  padding: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  display: block;
}
.codes-col .row .col {
    align-items: center;
    align-content: center;
    text-align: center;
    font-size: 1.6rem;
    font-family: monospace;
}
</style>

<script lang="js">
export default      {
    props           : {
        data        : { type: Array }
    },
    data            () {
        return      {
            loading : false,
            columnA : [],
            columnB : []
        }
    },
    methods         : {
        splitData   () {
            this.columnA.length = 0;
            this.columnB.length = 0;
            const size = this.data && this.data.length || 0;
            if (!size) { return; }
            let i = 0;
            while (i < size) {
                this.columnA.push(this.data[i++]);
                if (i >= size) { break; }
                this.columnB.push(this.data[i++]);
            }
        },
        getColumnB  (index) {
            return (index < this.columnB.length) ?
                   this.columnB[index]           :
                   '';
        }
    },
    mounted         () {
        this.splitData();
    }
}
</script>